import { PATH } from '@/constants/path';
import Analytics from '@/pages/Analytics';
import Checkout from '@/pages/Checkout';
import CreateShippingCheckout from '@/pages/Checkout/components/CreateUpdate';
import EditAppearance from '@/pages/Checkout/EditAppearance';
import EditProductLineItems from '@/pages/Checkout/EditProductLineItems';
import ExitIframe from '@/pages/ExitIframe';
import GeneralSettings from '@/pages/GeneralSettings';
import Home from '@/pages/Home';
import Onboarding from '@/pages/Onboarding';
import Pricing from '@/pages/Pricing';
import Settings from '@/pages/Settings';
import Appearance from '@/pages/Settings/Components/Appearance';
import EstimateRules from '@/pages/Settings/Components/EstimateRules';
import CURule from '@/pages/Settings/Components/EstimateRules/components/CURule';
import Translation from '@/pages/Translation';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

interface IRouter {
  path: string;
  element: React.ReactNode;
}

const router: Array<IRouter> = [
  {
    path: PATH.DEFAULT.pathname,
    element: <Home />,
  },
  {
    path: PATH.RULE_SETUP.pathname,
    element: <EstimateRules />,
  },
  {
    path: PATH.CHECKOUT_EXTENSION.pathname,
    element: <Checkout />,
  },
  // {
  //   path: PATH.FEEDBACK.pathname,
  //   element: <FeedbackSDK />,
  // },
  {
    path: PATH.ANALYTICS.pathname,
    element: <Analytics />,
  },
  {
    path: PATH.GENERAL_SETTINGS.pathname,
    element: <GeneralSettings />,
  },
  {
    path: PATH.GEOLOCATION_VALIDITY.pathname,
    element: <GeneralSettings />,
  },
  {
    path: PATH.DISPLAY_POSITION.pathname,
    element: <GeneralSettings />,
  },
  {
    path: PATH.APPEARANCE.pathname,
    element: (
      <Settings>
        <Appearance />
      </Settings>
    ),
  },
  {
    path: PATH.TRANSLATION.pathname,
    element: <Translation />,
  },
  {
    path: PATH.PRICING_PLAN.pathname,
    element: <Pricing />,
  },
  {
    path: PATH.CREATE_RULE.pathname,
    element: <CURule />,
  },
  {
    path: PATH.EDIT_RULE.pathname,
    element: <CURule />,
  },
  {
    path: PATH.CREATE_CHECKOUT_EXTENSION.pathname,
    element: <CreateShippingCheckout />,
  },
  {
    path: PATH.EDIT_CHECKOUT_EXTENSION.pathname,
    element: <CreateShippingCheckout />,
  },
  {
    path: PATH.EDIT_CHECKOUT_APPEARANCE.pathname,
    element: <EditAppearance />,
  },
  {
    path: PATH.EDIT_CHECKOUT_PRODUCT_LINE_ITEMS.pathname,
    element: <EditProductLineItems />,
  },
  {
    path: PATH.WELCOME.pathname,
    element: <Onboarding />,
  },
  {
    path: PATH.EXIT_IFRAME.pathname,
    element: <ExitIframe />,
  },
];

const newUserRouter = [
  {
    path: PATH.PRICING_PLAN.pathname,
    element: <Pricing />,
  },
  {
    path: PATH.EXIT_IFRAME.pathname,
    element: <ExitIframe />,
  },
];
function RenderRouter({ newUser }: { newUser?: boolean }): JSX.Element {
  return (
    <Routes>
      {newUser
        ? newUserRouter.map((item: IRouter) => <Route key={item.path} path={item.path} element={item.element} />)
        : router.map((item: IRouter) => <Route key={item.path} path={item.path} element={item.element} />)}
      <Route path="*" element={<Navigate to={newUser ? PATH.PRICING_PLAN : PATH.DEFAULT} replace />} />
    </Routes>
  );
}
export default RenderRouter;
